// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/front/unocms-v4/core.scss
// module id = 19
// module chunks = 0